import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { NextPageContext } from 'next';
import { apolloClient } from '@/api/apolloClient';
import {
  GET_CATEGORY,
  GET_CATEGORY_ID,
} from '@/api/queries/categories.queries';
import { getCategoryPath } from '@/utils/helpers';
import {
  GetCategoryIdResponse,
  GetCategoryResponse,
} from '@/api/types/categories.types';

export async function getCurrentCategory(
  client: ApolloClient<NormalizedCacheObject>,
  context: NextPageContext
) {
  const categoryPath = getCategoryPath(context.asPath);

  const category = await apolloClient<GetCategoryResponse>(
    client,
    {
      query: GET_CATEGORY,
      variables: { path: categoryPath },
    },
    context
  );

  return category?.data?.category || null;
}

export async function getCurrentCategoryId(
  client: ApolloClient<NormalizedCacheObject>,
  context: NextPageContext
) {
  const categoryPath = getCategoryPath(context.asPath);

  const category = await apolloClient<GetCategoryIdResponse>(
    client,
    {
      query: GET_CATEGORY_ID,
      variables: { path: categoryPath },
    },
    context
  );

  return category?.data?.category || null;
}
